import { useEffect, useRef, useState } from "react";
import personIcon from "../../assets/img/person-icon.png";
import { hideLoader, showLoader } from '../../components/loader';
import { toast } from 'react-toastify';
import * as $ from "jquery";
import { useLocation } from "react-router-dom";
import { Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl } from "../../utils/url";

const getErrors = (errors) => {
    const errorList = []
    if (errors?.handle)
        errors?.handle?.map((val) => errorList?.push(val))
    if (errors?.title)
        errors?.title?.map((val) => errorList?.push(val))
    if (errors?.description)
        errors?.description?.map((val) => errorList?.push(val))
    if (errors?.imageData)
        errors?.imageData?.map((val) => errorList?.push(val))
    if (errors?.theme)
        errors?.theme?.map((val) => errorList?.push(val))
    if (errors?.step)
        errors?.step?.map((val) => errorList?.push(val))

    return errorList
}
function slugify(text, divider = '-') {
    // replace non letter or digits by divider
    text = text.replace(/[^\p{L}\d]+/gu, divider);

    // transliterate
    text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    
    // remove unwanted characters
    text = text.replace(/[^-\w]+/g, '');

    // trim
    text = text.replace(new RegExp(`^${divider}+|${divider}+$`, 'g'), '');

    // remove duplicate divider
    text = text.replace(new RegExp(`${divider}+`, 'g'), divider);

    // lowercase
    text = text.toLowerCase();

    if (!text) {
        return null;
    }

    return text;
}
const Step3 = ({ moveNext, moveBack, imageBlob }) => {
    const dispatch = useDispatch()
    const { state } = useLocation();
    const [error, setError] = useState([])
    const [allThemes, setAllThemes] = useState([]);
    const [value, setValue] = useState({
        title: localStorage?.handle ?? localStorage?.user, description: localStorage?.company_description ?? null, step: 2, handle:slugify(localStorage?.handle ?? localStorage?.user) ,imageData:(localStorage?.company_logo ?? null)
    });
    const [selectedTheme, setSelectedTheme] = useState({header:"#11151a",background:"#212930",font:"#ffffff"});
    const { uploadImageReducer } = useSelector(state => state)
    const profilePicRef = useRef(null)
    const textareaRef = useRef(null);
    const handleChange = (e) => {
        // setValue({ ...value, [e.target.name]: e.target.value });
        const { name, value: inputValue } = e.target;
        let newValue = { ...value, [name]: inputValue };
    
        if (name === 'title') {
            newValue.handle = slugify(inputValue);
        }
    
        setValue(newValue);
    };
    const handleThemeChange = (e) => {
        setValue({ ...value, ["theme"]: e.target.id });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, "next", value)
    };

    useEffect(() => {
        try {
            const state = JSON.parse(localStorage?.backStepValue)
            console.log("state",state)
            if (state?.title || state?.description || state?.theme) {

                // dispatch({ type: "SET_UPLOAD_IMAGE", payload: { imageData: response } })

                setValue({ ...value, ...state })
                profilePicRef.current.src = state?.imageData ? state?.imageData : personIcon
            }
        } catch { }
    }, [localStorage?.backStepValue])
    const onSubmit = (e, from, values) => {
        showLoader();
        setError([]);
        var myHeaders = new Headers();

        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData();
        if(profilePicRef?.current?.src != localStorage?.company_logo && profilePicRef?.current?.src != "https://imagedelivery.net/tqC70bVt8T6GtQUXNsa2-g/743efd57-1c7a-4ea5-402b-ec349ceae400/public"){        
            formdata.append("imageData", uploadImageReducer?.imageData)
        }
        for (const key in values) {
            if (Object.hasOwnProperty.call(values, key)) formdata.append(key, values[key]);
        }

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch(apiUrl + "/walkthrough", requestOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    if (from == "next" || from == "skip") {
                        dispatch({ type: "RESET_UPLOAD_IMAGE" })
                        const slug = response?.data?.default_project;
                        dispatch({ type: "SET_SLUG", payload: { slug: slug, basePath: "/project/" + slug, newChange: false } })
                        localStorage.setItem("new_user", true)
                        localStorage.setItem("slug", slug)
                        toast.success(response?.status_message)

                        hideLoader()
                        moveNext(e, 3)
                    }
                    else if (from == "back") {
                        moveBack(e, response)

                        hideLoader()
                    }
                }
                else {
                    setError(getErrors(response?.errors))
                    toast.error(response?.status_message)

                    hideLoader()
                }

            }).catch((err) => {
                hideLoader()
            })
    }
    const openUploadModal = () => $(".profile_pic_upload_modal").click();

    const getTheme = async (e) => {
        showLoader()
        fetch(apiUrl + "/themes")
            .then(async (res) => {
                hideLoader()
                const response = await res.json();
                setAllThemes(response?.data)
            }).catch((err) => {

                // console.log(err)
                hideLoader()
            })
    }
    // useEffect(() => {
    //     if (allThemes.length == 0) getTheme()
    // }, [])

    useEffect(() => {
        if (state?.description && state?.title) setValue({ ...value, ...state })
    }, [state])

    useEffect(()=>{
        const Theme = allThemes?.find(val => val.name.toLowerCase() == value?.theme.toLowerCase() );
        if (Theme) {
            setSelectedTheme({
                header: JSON.parse(Theme?.meta)?.header?.color,
                background:JSON.parse(Theme?.meta)?.background?.color,
                font:JSON.parse(Theme?.meta)?.background?.font,
            });
        }
    },[value?.theme])

    $(document).on('click', '.theme-selection-div', function () {

        // $(".theme-selection-div").removeClass('selected-theme');
        // $(".theme-selection-div").addClass('selected-theme');
        var src_value = $(this).find('span').attr('data-bg');

        $("input[name='theme_color']").val(src_value);
    });
    function autoResize(textarea) {
        if (textarea.value.length > 70) {
            textarea.style.height = "auto";
            textarea.style.height = textarea.scrollHeight + "px";
        }else {

            textarea.style.height = "30px";
        }
    }
    useEffect(() => {
        if (textareaRef?.current) {
            autoResize(textareaRef?.current);
        }
    }, [value?.description]);
    return (
        <>
            <div>
                <div className="step-heading">Confirm workspace details</div>
                <form action=""  method="post" className='step-form' role="form" onSubmit={(e) => handleSubmit(e)}>
                    <div>
                        <div class="profile-pic-box mt-20px">
                            <div className="uploded-imge-area">
                                <img src={value?.imageData && value?.imageData != 'null' ? value?.imageData : "https://imagedelivery.net/tqC70bVt8T6GtQUXNsa2-g/743efd57-1c7a-4ea5-402b-ec349ceae400/public"} width="80px" id="image_file_preview" class="image_file_preview clickable" ref={profilePicRef} />
                            </div>
                            <div style={{cursor:"pointer"}}>
                                <span className="step-label">Workspace logo</span>
                                <div className="register-btn mt-1" onClick={openUploadModal}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333"/>
                                    </svg>Upload New
                                </div>
                                <input id="image_file_input" type="file" accept=".gif, .ico, .png, .jpg, .jpeg, .svg" class="form-control" style={{ display: "none" }} name="image" />
                                <input type="hidden" name="image" value="" id="pp_image" />
                            </div>
                        </div>
                        <div>
                            {error?.length > 0 && (
                                <Alert variant="danger">
                                    {error?.map((val, index) => <li key={index}>{val}</li>)}
                                </Alert>
                            )}
                            <div class="form-group mt-20px">
                                <label htmlFor="" className="step-label">Workspace name</label>
                                <div class='input2u'>
                                    <input type="text" required name="title" value={value?.title} onChange={handleChange}
                                        placeholder="Workspace Name" className="pl-3 fs-12" />
                                </div>
                            </div>
                            <div class="form-group mt-20px">
                                <label htmlFor="" className="step-label">Workspace handle</label>
                                <div class='d-flex input2u'>
                                <span id="input-prefix" className="fs-12">
                                    genpa.ge/
                                </span>
                                    <input type="text" name="handle" required value={value?.handle} onChange={handleChange}
                                        placeholder="handle" className="fs-12 pl-3" />
                                </div>
                            </div>
                            <div class="form-group mt-20px">
                                <label htmlFor="" className="step-label">Company description</label>
                                <textarea
                                    ref={textareaRef}
                                      type="text"
                                      value={value?.description  && value?.description != 'null' ? value?.description : ''}
                                      className="zaapGlobal-input hidden-scroll"
                                      name="description"
                                      placeholder={"Tell us about your company. This is used to build your campaign."}
                                      style={{minHeight: "50px"}}
                                      onChange={handleChange}
                                  >
                                  </textarea>
                            </div>
                        </div>
                    </div>
                    <div className='walkthrough-steps-footer'>
                    <button
                        onClick={(e) =>
                            onSubmit(e, "back", {
                                back: 1,
                                step: 2
                            })} type="button" className="register-btn border-0"
                        data-backstep="1">Back</button>
                    <button type="submit" name="submit"  className="fs-12 w-100 shadow-none  project-blue-btn ">
                        Continue
                    </button>
                    </div>
                </form>
            </div>


        </>
    )
}
export default Step3